import React from 'react';
import { defaultDisplaySetting } from '../component/helpers/preSelectedFilters';

const chaptersConceptsStyles = {
  fontSize: '14px',
  color: '#999',
  marginRight: '4px',
  marginLeft: '10px',
};

const subjectNameStyles = {
  fontSize: '16px',
  color: '#333',
  marginRight: '4px',
  marginLeft: '9px',
};
const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  marginTop: '5px',
};

const chapterSection = {
  display: 'flex',
  marginLeft: '0',
  padding: '7px 0px 7px 27px',
}

function getIndex(subjects: any, subjectName: string) {
  for (let i = 0; i < subjects.length; i++) {
    if (subjects[i].name === subjectName) return i;
  }
  return -1;
}

function getConceptCount(details: any, subjectTab: string, displaySettings: any=defaultDisplaySetting) {
  try {
    const { children, subjects } = details;
    let weekNo = 0;
    let subName = 'Physics';
   const{showWeeks,showChapters,showConcepts}=displaySettings;
    // initialize all concept count to 0
    subjects.forEach((subject: any) => (subject.conceptCount = 0));
    if (showChapters && !showWeeks && !showConcepts) {
      subjects.forEach((subject: any) => (subject.chapterCount = 0));
    }

    if (showChapters && showConcepts) {
      //for each week
      children.forEach((week: any) => {

        if (showWeeks) {
          //for each chapter
          week.children.forEach((chapter: any) => {
            //get index of subject and add count of concepts in that chapter
            if (showChapters && showConcepts) {
              subjects[getIndex(subjects, chapter.subjectName)].conceptCount += ((chapter && chapter.concepts && chapter.concepts.length) || 0);
            } else if (!showChapters) {
              if (weekNo !== week.weekNo) {
                subjects[getIndex(subjects, chapter.subjectName)].conceptCount += ((week && week.children && week.children.length) || 0);
                weekNo = week.weekNo;
              }
            }
          });
        } else {
          subjects[getIndex(subjects, week.subjectName)].conceptCount += ((week && week.children && week.children.length) || 0);
        }
      });
    } else if (showChapters) {
      children.forEach((week: any) => {

        if (showWeeks) {
          //for each chapter
          week.children.forEach((chapter: any) => {
            //get index of subject and add count of concepts in that chapter
           
                subjects[getIndex(subjects, chapter.subjectName)].conceptCount += ((week && week.children && week.children.length) || 0);
              
          });
        } else {
          subjects[getIndex(subjects, week.subjectName)].chapterCount++;
          subjects[getIndex(subjects, week.subjectName)].conceptCount += ((week && week.concepts && week.concepts.length) || 0);
        }
      });
    } else if (showConcepts) {
      children.forEach((week: any) => {

        if (showWeeks) {
          //for each chapter
          week.children.forEach((chapter: any) => {
            subjects[getIndex(subjects, chapter.subjectName)].conceptCount++;
          });
        } else {
          subjects[getIndex(subjects, week.subjectName)].conceptCount++;
        }
      });
    }

    if (subjectTab === 'All Subjects') {
      return subjects.map((subject: any) => (
        subject.conceptCount > 0 && (
        <div
          style={chapterSection}
          key={subject.name}
        >
          <span style={subjectNameStyles}>{subject.name}</span>
            <span style={chaptersConceptsStyles}>
              {showChapters ?
                <>{subject.chapterCount} Chapters</>
                : ''}
              {showChapters && showConcepts || (!showWeeks && !showConcepts)?
                <span style={bullets}>&bull;</span> : ''}
              {showConcepts || (!showWeeks && !showConcepts)?
                <>{subject.conceptCount} Concepts</>
                : ''}
          </span>
        </div>)
      ));
    }

    for (let i = 0; i < subjects.length; i++) {
      if (subjects[i].name === subjectTab) {
        return (
          subjects[i].conceptCount > 0 ?
          <div
            style={{
              display: 'flex',
              marginLeft: '2%',
            }}
            key={subjects[i].name}
          >
            <span style={subjectNameStyles}>{subjects[i].name}</span>
            <span style={chaptersConceptsStyles}>
            {showChapters ?
                <>{subjects[i].chapterCount} Chapters</>
                : ''}
              <span style={bullets}>&bull;</span>
              {showConcepts || (!showWeeks && !showConcepts)?
                <>{subjects[i].conceptCount} Concepts</>
                : ''}
            </span>
          </div>
          : null
        );
      }
    }
  } catch (error) {
    return <span style={chaptersConceptsStyles}>{`0 Chapters 0 Concepts`}</span>;
  }
}

export default getConceptCount;
